module.exports = __webpack_public_path__ + "img/71.df337e07.jpg";